module.exports = __webpack_public_path__ + "img/vps-hourly.0eba099.svg";